module.exports = __webpack_public_path__ + "media/effect1.348be8f6.wav";